import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import logo from '../images/logo.svg';
import { colors, glassCard, typography } from '../theme';

const roles = [
    { icon: '👤', label: 'Customer',   sub: 'Browse shops, book appointments\nand walk in with a QR scan',     path: '/signin?role=customer', color: colors.secondary },
    { icon: '✂️', label: 'Shop Owner', sub: 'Manage your shop, barbers,\nbookings and walk-in queue',          path: '/signin?role=owner',    color: colors.primary },
    { icon: '💈', label: 'Barber',     sub: 'Sign in or join a shop with invite code',                         path: '/signin?role=barber',   color: colors.success },
];

const RoleSelectPage = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: colors.bgGradient, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', px: 3, py: 4 ,}}>

            {/* Logo + title */}
            <Box sx={{ textAlign: 'center', mb: 5 }}>
                <img src={logo} alt="DigitalQ" style={{ width: 200, height: 'auto', marginBottom: 16 }} />
                <Typography sx={{ fontFamily: typography.poppins, fontSize: 26, fontWeight: 700, color: colors.textPrimary, lineHeight: 1.2 }}>
                    Digital Waiting Line
                </Typography>
                <Typography sx={{ fontSize: 14, color: colors.textFaint, mt: 1 }}>
                    A simple digital queue system that lets customers scan, take a number and wait anywhere while you manage everything in real time.
                </Typography>
            </Box>

            {/* Role cards */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', maxWidth: 360 ,}}>
                {roles.map(({ icon, label, sub, path, color }) => (
                    <Box key={label} onClick={() => navigate(path)} sx={{
                        display: 'flex', alignItems: 'center', gap: 2,
                        bgcolor: colors.bgCard, border: `1px solid ${colors.border}`,
                        borderRadius: 3, p: 2, cursor: 'pointer', transition: 'all .2s',
                        '&:hover': { borderColor: color + '88', transform: 'translateX(4px)' , color:colors.bg},
                         ...glassCard
                    }}>
                        {/* Icon circle */}
                        <Box sx={{ width: 52, height: 52, borderRadius: '50%', bgcolor: colors.bg, border: `1px solid ${colors.textPrimary}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 24 }}>
                            {icon}
                        </Box>

                        {/* Text */}
                        <Box sx={{ flex: 1 }}>
                            <Typography sx={{ fontFamily: typography.poppins, fontSize: 16, fontWeight: 700, color:colors.textPrimary, lineHeight: 1.2, mb: 0.3 }}>
                                {label}
                            </Typography>
                            <Typography sx={{ fontSize: 12, color: colors.textPrimary, whiteSpace: 'pre-line', lineHeight: 1.4 }}>
                                {sub}
                            </Typography>
                        </Box>

                        <Typography sx={{ fontSize: 18, color: colors.border }}>›</Typography>
                    </Box>
                ))}
            </Box>

            <Typography sx={{ fontSize: 13, color: colors.textFaint, mt: 4 }}>
                Already have an account?{' '}
                <Typography component="span" onClick={() => navigate('/signin')} sx={{ color: colors.textPrimary, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>
                    Sign in
                </Typography>
            </Typography>
        </Box>
    );
};

export default RoleSelectPage;